<div class="row text-primary py-4 container mx-auto">
  <div class="col-12 col-md-3">
    <div class="bg-white rounded p-3 text-center">
      <h4 translate>Questions</h4>
      <div class="d-flex justify-content-center align-items-center flex-wrap mt-2">
        <ng-container *ngFor="let question of questions; index as i; trackBy: trackByIndex">
          <div class="question-pin shadow rounded-circle d-flex justify-content-center align-items-center bolder m-2"
               [class.bg-primary]="isAnswered(question.question)"
               [class.text-white]="isAnswered(question.question)">
            {{ i+1 }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-9">
    <div class="bg-white rounded p-4">
      <h4 class="mb-2">Reading part 5 : Incomplete sentences</h4>
      <p>
        For each question you will see an incomplete sentence. Four words or phrases are given beneath each sentence. You are to choose the one word or phrase that best completes the sentence.
      </p>
      <p>
        There are 30 questions in this test.
      </p>
    </div>

    <!-- Questions -->
    <div class="bg-white rounded p-4 mt-3" *ngFor="let question of questions; index as i; trackBy: trackByIndex">
      <h5 class="mb-3 bolder">{{ i+1 }}.</h5>
      <div class="row my-2">
        <div class="col-6">
          <p [innerHTML]="question.question.translation"></p>
        </div>
        <div class="col-6 d-flex flex-column justify-content-evenly">
          <ng-container *ngFor="let answer of question.answers; let affirmationIndex = index; trackBy: trackByIndex">
            <button class="btn rounded btn-block shadow bolder mx-2 h-100 text-left p-3"
                    [class.btn-primary]="isSelected(question.question, answer)"
                    [class.text-white]="isSelected(question.question, answer)"
                    [class.btn-white]="!isSelected(question.question, answer)"
                    [class.text-primary]="!isSelected(question.question, answer)"
                    (click)="selectAnswer(question.question, answer)">
              <span class="mr-2 bolder">{{ letters[affirmationIndex] }}</span> {{answer.translation}}
            </button>
          </ng-container>
        </div>
      </div>
    </div>


    <button class="btn btn-primary btn-block bolder mt-3" (click)="next()" translate>Suivant</button>
  </div>
</div>
